import queryString from 'query-string';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const actions = createActions({
  ADMIN: {
    QUERY_ADMIN_TASKS: (filter) => ({ filter }),
    API: {
      QUERY_ADMIN_TASKS: apiResourceActionCreator('tasks')
    }
  }
})

export const apiAction = (authToken, filter) => commonApiActions.authenticated.get(`${API_ENDPOINT}/tasks?${queryString.stringify(filter)}`, authToken, actions.admin.api.queryAdminTasks);

function* queryAdminTasks(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.filter));
}

const configuration = {
  name: 'queryAdminTasks',
  action: actions,
  sagas: queryAdminTasks,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetchingTask: true,
      error: null
    }),
    success: (state, action) => ({
      ...state,
      adminTasks: action.payload.tasks,
      isFetchingTask: false,
      error: null
    }),
    failed: (state, action) => ({
      ...state,
      isFetchingTask: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/admin/configurations/queryAdminTasks.js